export const breakpoints = {
    mobile: `max-width: 1200px`,
    desktop: `min-width: 1200px`,
  };
  